export default __webpack_public_path__ + "static/media/calendar-icon.150e38ea.svg";